var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "11.556px",
    height: "13.001px",
    viewBox: "0 0 13 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.82821V12.1615C0.5 12.9593 1.1467 13.606 1.94444 13.606H10.6111C11.4089 13.606 12.0556 12.9593 12.0556 12.1615V7.82821M6.27782 9.27214L6.27782 0.605469M6.27782 0.605469L8.8056 3.13325M6.27782 0.605469L3.75004 3.13325",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportButton);
export default __webpack_public_path__ + "static/media/exportButton.2adeaeec7baca22a004ad8bb77b3cc79.svg";
export { ForwardRef as ReactComponent };